const c = {
  name: "Location",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12,5C9.8,5,8,6.8,8,9c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C16,6.8,14.2,5,12,5z M10,9c0-1.1,0.9-2,2-2s2,0.9,2,2
			c0,1.1-0.9,2-2,2S10,10.1,10,9z"/>
		<path class="st0" d="M12,1C7.6,1,4,4.6,4,9c0,3.8,1.9,7.3,3.7,9.7c0.9,1.2,1.8,2.2,2.5,2.9c0.3,0.3,0.6,0.6,0.8,0.8
			c0.1,0.1,0.2,0.2,0.2,0.2c0,0,0.1,0,0.1,0.1l0,0l0,0l0,0c0,0,0,0,0.7-0.8l-0.7,0.8l0.7,0.6l0.7-0.6L12,22c0.7,0.8,0.7,0.8,0.7,0.8
			l0,0l0,0l0,0l0,0c0,0,0,0,0.1-0.1c0.1,0,0.1-0.1,0.2-0.2c0.2-0.2,0.5-0.5,0.8-0.8c0.7-0.7,1.6-1.7,2.5-2.9C18.1,16.3,20,12.8,20,9
			C20,4.6,16.4,1,12,1z M12.4,20.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.1-0.1-0.2-0.2-0.4-0.4c-0.6-0.6-1.5-1.6-2.3-2.7
			C7.6,15.2,6,12.2,6,9c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6c0,3.2-1.6,6.2-3.3,8.5C13.9,18.7,13,19.6,12.4,20.3z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Location
};
